import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../../services/apiCaller/cl_index";
import { endpoints } from "../../../api/ApiEndPoints";

const initialState={
    staticContent:''
}


export const aboutSlice=createSlice({
    name:'about',
    initialState,
    reducers:{
        setStaticContent:(state,action)=>{
            state.staticContent=action.payload
        }
    }
})

export const {setStaticContent}=aboutSlice.actions;


export const setAboutContent=(brandid)=>(dispatch)=>{
    const url=endpoints.aboutStaticContent + "/" + brandid + "?language=en";
    postRequest(url).then((res) => {
        if (res?.status === 200) {
          dispatch(setStaticContent(res?.data));
        }else{
          dispatch(setStaticContent([]))
        }
      });
}
export default aboutSlice.reducer;

